import { Pill } from "@clipboard-health/ui-components";
import { type Theme } from "@mui/material";

import { type PlacementData } from "../../../types/placement";
import { getVerifiedType, PLACEMENT_VERIFIED_TYPES } from "../../../utils/verified-placement";

interface PlacementVerifiedTypePillProps {
  interviewSettings: PlacementData["interviewSettings"];
  webApplicationLink: PlacementData["webApplicationLink"];
  hiringEvents: PlacementData["hiringEvents"];
  allowRequestInterview: PlacementData["allowRequestInterview"];
}

export function PlacementVerifiedTypePill(props: PlacementVerifiedTypePillProps) {
  const { interviewSettings, webApplicationLink, hiringEvents, allowRequestInterview } = props;

  const verifiedType = getVerifiedType({
    interviewSettings,
    webApplicationLink,
    hiringEvents,
    allowRequestInterview,
  });

  const configs = {
    [PLACEMENT_VERIFIED_TYPES.INSTANT_INTERVIEW]: {
      label: "Instant interview",
      backgroundColor: (theme: Theme) => theme.palette.intent?.success.background,
      color: (theme: Theme) => theme.palette.intent?.success.text,
      iconColor: (theme: Theme) => theme.palette.intent?.success.text,
      icon: "bolt-filled" as const,
    },
    [PLACEMENT_VERIFIED_TYPES.REQUEST_INTERVIEW]: {
      label: "Request to interview",
      backgroundColor: (theme: Theme) => theme.palette.components?.avatar.quaternary,
      color: (theme: Theme) => theme.palette.intent?.neutral.text,
      iconColor: (theme: Theme) => theme.palette.intent?.neutral.text,
      icon: "plane" as const,
    },
    [PLACEMENT_VERIFIED_TYPES.APPLY]: {
      label: "Instant apply",
      backgroundColor: (theme: Theme) => theme.palette.placement?.apply.feature.background,
      color: (theme: Theme) => theme.palette.intent?.neutral.text,
      iconColor: (theme: Theme) => theme.palette.intent?.neutral.text,
      icon: "user-starred" as const,
    },
    [PLACEMENT_VERIFIED_TYPES.APPLY_ON_WEB]: {
      label: "Apply on web",
      backgroundColor: (theme: Theme) => theme.palette.background.secondary,
      color: (theme: Theme) => theme.palette.text.secondary,
      iconColor: (theme: Theme) => theme.palette.text.secondary,
      icon: "resume" as const,
    },
  };

  return (
    <Pill
      label={configs[verifiedType].label}
      variant="outlined"
      size="small"
      iconType={configs[verifiedType].icon}
      backgroundColor={configs[verifiedType].backgroundColor}
      color={configs[verifiedType].color}
      iconColor={configs[verifiedType].iconColor}
      sx={{
        pl: 3,
        border: "transparent",
      }}
    />
  );
}
